<template>
  <v-dialog v-model="dialog" persistent max-width="500px" @keydown.esc="close()">
    <v-card>
      <v-card-title> </v-card-title>

      <v-card-text>
        <v-container grid-list-xl>
          <v-col>
            <v-flex>
              <v-menu ref="menu1" :close-on-content-click="false" v-model="menu1" :nudge-right="40"
                transition="scale-transition" offset-y max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-on="on" v-model="dateFormatted" label="Data" persistent-hint
                    prepend-icon="event" readonly class="mb-0 pb-0" style="width: auto">
                  </v-text-field>
                </template>

                <v-date-picker v-model="date" no-title @input="menu1 = false" :first-day-of-week="1"
                  locale="it-it"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex>
              <v-textarea label="Note" v-model="dati.Nota" outlined maxlength="500" autofocus></v-textarea>
            </v-flex>
          </v-col>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-btn color="black" text icon @click.native="eliminaNota()">
          <v-icon medium>delete</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click.native="close()">Annulla</v-btn>
        <v-btn color="primary" text @click.native="salvaNota()">Salva</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  get_noteClienti,
  save_noteClienti,
  delete_noteClienti,
} from "@/api/api.agenti.js";

export default {
  props: {
    dialog: { Boolean, default: false },
    codCliente: { String, default: "" },
    idNota: { Number, default: 0 },
  },

  data: () => ({
    dati: [],

    date: null,
    dateFormatted: null,
    menu1: false,
  }),

  methods: {
    caricaDati() {
      // Reset
      this.dati = [];

      // Controllo nuovo
      if (this.idNota == 0) {
        this.dati = {
          Id: 0,
          CodCliente: this.codCliente,
          Nota: "",
          Data: null,
        };

        // Imposto la data odierna
        var now = new Date();
        let year = "" + now.getFullYear();
        let month = "" + (now.getMonth() + 1);
        if (month.length == 1) {
          month = "0" + month;
        }
        let day = "" + now.getDate();
        if (day.length == 1) {
          day = "0" + day;
        }

        this.dateFormatted = day + "/" + month + "/" + year;

        return;
      }

      get_noteClienti(this.codCliente + "/" + this.idNota)
        .then((res) => {
          this.dati = res.data;

          // Imposto la data sul calendario
          this.dateFormatted = this.dati.Data;
        })
        .catch((err) => {
          console.log("noteCliente.vue " + err);
        });
    },

    salvaNota() {
      if (this.dati.Nota.length == 0) return;

      // Imposto la data
      this.dati.Data = this.dateFormatted;

      save_noteClienti(this.dati)
        .then((res) => {
          this.$emit("caricaNote");
        })
        .catch((err) => {
          console.log(err.response.data.Message);
        });

      this.close();
    },

    eliminaNota() {
      if (this.idNota == 0) return;

      this.$root
        .$confirm("Elimina", "Vuoi eliminare il dato ?")
        .then((confirm) => {
          if (!confirm) return;

          delete_noteClienti(this.idNota)
            .then((res) => {
              this.$emit("caricaNote");
            })
            .catch((err) => {
              console.log(err.response.data.Message);
            });

          this.close();
        });
    },

    close() {
      this.$emit("close");
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
  },

  watch: {
    dialog(val) {
      if (!val) return;

      this.caricaDati();
    },

    date(val) {
      this.dateFormatted = this.formatDate(this.date);
    },
  },

  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },
};
</script>
